<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0 mr-12">

    <div class="pl-16 pr-8 py-16 h-52 m-5px" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h3 pr-16 cardHeader">Médicos</div>
        <app-year-toggle (YearChange)="yearChanged($event)"></app-year-toggle>
    </div>

    <div *ngIf="isLoading" class="m-auto">
        <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
        </mat-progress-spinner>
    </div>
    <div *ngIf="!isLoading">
        <div class="fuse-card auto-width mat-card ml-12 mr-12 mb-12 p-0"
            *ngIf="!doctorList || (doctorList && doctorList.length === 0)">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                class="dis-block p-10">
                <p>No hay médicos para el coordinador</p>
            </div>
        </div>
        <div class="fuse-card auto-width mat-card ml-12 mr-12 mb-12 p-0" *ngFor="let doctor of doctorList">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
                class="dis-block p-10">
                <div class="doctor-tbl">
                    <table>
                        <caption></caption>
                        <thead>
                            <th></th>
                            <th></th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <span class="text-bold">{{doctor.nombre}}</span>
                                    <button class="mat-raised-button mat-button-base doctor-visit">{{doctor.nDespachos |
                                        number : '2.0-0'}}</button>
                                </td>
                                <td></td>
                                <td class="text-right p-r-10">
                                    <mat-icon (click)="openAddEditPopup(false, doctor)"
                                        class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate add-date">
                                        add</mat-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <!-- doctor date slider -->
                <div class="m-t-5 m-b-5 carousel-coordinator">

                    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                        <div class="btn-w-100"
                            *ngIf="(doctorVisitList | listFilter: 'DOCTORID': doctor.medicoId).length > 0">
                            <p-carousel [value]="doctorVisitList | listFilter: 'DOCTORID': doctor.medicoId"
                                [numVisible]="8" [numScroll]="1" [styleClass]="'visit-carousel'" [responsiveOptions]="responsiveOptions">
                                <ng-template let-visit pTemplate="item">
                                    <button [ngClass]="{'add-date-active' : doctor.selectedVisitaId === visit.id}"
                                        class="mat-raised-button mat-button-base btn-date"
                                        (click)="toggleDetails(doctor, visit.id)">
                                        <span *ngIf="!visit.realizada"> **</span>
                                        <span *ngIf="visit.realizada"> {{visit.realizada | date : 'dd/MM'}}</span>
                                    </button>
                                </ng-template>
                            </p-carousel>
                        </div>
                        <div class="btn-w-100"
                            *ngIf="(doctorVisitList | listFilter: 'DOCTORID': doctor.medicoId).length === 0">
                            Actualmente no hay datos de visitas disponibles
                        </div>
                    </div>

                </div>
                <!--/ doctor date slider -->

                <div *ngIf="doctor.showVisit && doctor.selectedVisitDetails">
                    <table class="mat-table coordinator-client-tbl">
                        <caption></caption>
                        <thead>
                            <th></th>
                            <th></th>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="font-bold">
                                    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
                                        <span *ngIf="doctor.selectedVisitDetails.coordinador">Coordinador:
                                            {{doctor.selectedVisitDetails.coordinador}}</span>
                                        <span *ngIf="doctor.selectedVisitDetails.asistentes">Asistentes:
                                            {{doctor.selectedVisitDetails.asistentes}}</span>
                                    </div>
                                </td>
                                <td></td>
                            </tr>
                            <tr class="line-h-11">
                                <td>{{doctor.selectedVisitDetails.comentarios}}</td>
                                <td class="text-right p-r-10">
                                    <mat-icon (click)="openAddEditPopup(true, doctor)"
                                        class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate" role="img">
                                        edit</mat-icon>
                                    <mat-icon (click)="onDeleteVisita(doctor.selectedVisitDetails.id)"
                                        class="mat-icon material-icons mat-icon-no-color f-s-19 notranslate" role="img">
                                        delete</mat-icon>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


</div>